import React from 'react'
// components
import Row from './components/Row'
// views
import { TableBody, TableHeader, TableHeaderCell, TableWrapper } from '../../views'
// types
import { IAiSuggestedRecord, IField } from 'types/graphql'

type SelectedId = { id: string; action: 'copy' | 'reference' }
type SuggestionWithId = IAiSuggestedRecord & { id: string }

interface Props {
  fields: IField[]
  suggestions: SuggestionWithId[]
  selectedIds: SelectedId[]
  onButtonClick: (id: string, action: 'copy' | 'reference') => void
}

const RisksSuggestions: React.FC<Props> = ({ fields, suggestions, onButtonClick, selectedIds }) => {
  return (
    <TableWrapper>
      <TableHeader>
        {fields.map((item) => (
          <TableHeaderCell key={item.id}>{item.label}</TableHeaderCell>
        ))}
      </TableHeader>
      <TableBody>
        {suggestions.map((item) => (
          <Row
            key={item.id}
            templateFields={fields}
            form={`AI_RISK_${item.id}`}
            fieldValues={item.fields}
            existingRecordId={item.existingRecordId}
            matchedFilter={item.matchedFilter}
            currentAction={selectedIds.find((s) => s.id === item.id)?.action ?? null}
            onButtonClick={(action) => onButtonClick(item.id, action)}
          />
        ))}
      </TableBody>
    </TableWrapper>
  )
}

export default RisksSuggestions
